<div class="main">
  <div class="main-top">
    <div class="content-left" *ngIf="listItem">
      <span class="content-span1">{{ listItem['applicant']['formid'] }}</span>
      <span class="content-span2">{{ listItem['applicant']['emplid'] }}</span>
      <span class="content-span2">{{ listItem['applicant']['name'] }}</span>
      <span class="content-span2">{{ listItem['applicant']['applayTime'] }}</span>
      <span style="color: rgb(187, 102, 102); font-weight: bold;">{{ version }}</span>
    </div>
    <div class="content-right">
      <button (click)="detailData()">{{ url['btnName'] }}</button>
    </div>
  </div>

  <nz-table #fixedTable nzTableLayout="fixed" [nzShowPagination]="false" *ngIf="listItem" [nzData]="listItem['signStatus']" class="main-bottom">
    <thead>
      <tr>
        <th scope="col" nzWidth="25%">{{ 'DocApp.Location' | translate }}</th>
        <th scope="col" nzWidth="30%">{{ 'DocApp.DemandsDescription' | translate }}</th>
        <!-- <th nzEllipsis scope="col" nzWidth="11%">
          <span nz-tooltip [nzTooltipTitle]="'DocApp.EngineeringCategory' | translate" nzTooltipPlacement="topLeft">{{ 'DocApp.EngineeringCategory' | translate }}</span>
        </th> -->
        <th scope="col" nzWidth="11%">{{ 'DocApp.EngineeringCategory' | translate }}</th>
        <th scope="col" nzWidth="13%">{{ 'Common.DocStatus' | translate }}</th>
        <th scope="col" nzWidth="7%" *ngIf="listItem['signStatus'][0].target !== underfined">Target</th>
        <th scope="col" nzWidth="7%" *ngIf="listItem['signStatus'][0].stopDays !== underfined">{{ 'Common.Pending' | translate }}</th>
        <th scope="col" nzWidth="7%" *ngIf="listItem['signStatus'][0].status !== underfined">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of fixedTable .data">
        <td nzEllipsis>
          <span nz-tooltip [nzTooltipTitle]="data.site" nzTooltipPlacement="topLeft">{{ data.site}}</span>
        </td>
        <td nzEllipsis>
          <span nz-tooltip [nzTooltipTitle]="data.descripption" nzTooltipPlacement="topLeft">{{ data.descripption}}</span>
        </td>
        <td nzEllipsis>
          <span nz-tooltip [nzTooltipTitle]="data.classfication" nzTooltipPlacement="topLeft">{{ data.classfication}}</span>
        </td>
        <td nzEllipsis>
          <span nz-tooltip [nzTooltipTitle]="data.statusValue" nzTooltipPlacement="topLeft">{{ data.statusValue}}</span>
        </td>
        <td *ngIf="data.target !== underfined">{{ data.target }}</td>
        <td>{{ data.stopDays }}</td>
        <td *ngIf="data.status !== underfined">
          <div  *ngIf = "data.status ==='red'||data.status ==='green'"  class="circle" [ngClass]="{activeDiv: data.status === 'red'}"></div>
          <span *ngIf = "data.status !='red'&&data.status !='green'" style="color: rgb(187, 102, 102);font-weight: bold;">{{data.status}}</span>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
